import { useEffect, useState } from "react";
import { Send, X } from "lucide-react";

const TG_URL = "https://t.me/lunaaitrade";
const TG_TEXT = "Her Türlü Soru ve Öneriler İçin Telegram Grubuna Katılın";

export const TelegramPopup = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!sessionStorage.getItem("tg_popup_seen")) {
      const t = setTimeout(() => setOpen(true), 700);
      return () => clearTimeout(t);
    }
  }, []);

  const close = () => {
    sessionStorage.setItem("tg_popup_seen", "1");
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div data-testid="telegram-popup" className="fixed inset-0 z-[100] flex items-center justify-center px-4"
      style={{ background: "rgba(3,7,18,0.72)", backdropFilter: "blur(6px)" }} onClick={close}>
      <div className="relative w-full max-w-sm rounded-2xl border p-7 text-center fade-up"
        style={{ background: "var(--bg-card)", borderColor: "var(--border-subtle)", boxShadow: "0 0 60px rgba(34,158,217,0.25)" }}
        onClick={(e) => e.stopPropagation()}>
        <button data-testid="telegram-popup-close" onClick={close}
          className="absolute right-4 top-4 p-1.5 rounded-lg border" style={{ borderColor: "var(--border-subtle)", color: "var(--text-muted)" }}>
          <X className="w-4 h-4" />
        </button>
        <div className="w-16 h-16 rounded-2xl mx-auto flex items-center justify-center mb-4"
          style={{ background: "rgba(34,158,217,0.15)", boxShadow: "0 0 30px rgba(34,158,217,0.35)" }}>
          <Send className="w-8 h-8" style={{ color: "#229ED9" }} />
        </div>
        <h3 className="text-lg font-bold mb-2">{TG_TEXT}</h3>
        <p className="text-sm mb-5" style={{ color: "var(--text-muted)" }}>Topluluğumuza katılın, güncel sinyalleri ve duyuruları kaçırmayın.</p>
        <a data-testid="telegram-popup-join" href={TG_URL} target="_blank" rel="noopener noreferrer"
          className="inline-flex w-full items-center justify-center gap-2 text-sm font-bold px-5 py-3 rounded-xl text-white transition-all hover:brightness-110"
          style={{ background: "linear-gradient(135deg,#229ED9,#1b7db3)" }}>
          <Send className="w-4 h-4" /> Telegram Grubuna Katıl
        </a>
      </div>
    </div>
  );
};

export const TelegramNotice = () => (
  <a data-testid="telegram-notice" href={TG_URL} target="_blank" rel="noopener noreferrer"
    className="flex items-center gap-3 rounded-2xl border px-5 py-4 transition-all hover:brightness-110"
    style={{ background: "linear-gradient(135deg, rgba(34,158,217,0.14), rgba(34,158,217,0.05))", borderColor: "rgba(34,158,217,0.35)" }}>
    <div className="w-10 h-10 rounded-xl flex items-center justify-center shrink-0" style={{ background: "rgba(34,158,217,0.2)" }}>
      <Send className="w-5 h-5" style={{ color: "#229ED9" }} />
    </div>
    <div className="min-w-0">
      <div className="text-sm font-bold" style={{ color: "var(--text-primary)" }}>{TG_TEXT}</div>
      <div className="text-[12px] font-mono-term truncate" style={{ color: "#5BC0EB" }}>{TG_URL}</div>
    </div>
    <span className="ml-auto text-[12px] font-bold px-3 py-1.5 rounded-full text-white shrink-0" style={{ background: "#229ED9" }}>Katıl</span>
  </a>
);
